export default "__VITE_ASSET__COjLlIQN__"